import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import AllProjects from '../components/Projects';
import SearchProjects from '../components/Projects/SearchProjects';
import CreateProjectButton from '../components/Projects/CreateProjectButton';
import ProjectSearchInput from '../components/Projects/ProjectSearchInput';

const Projects = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const query = params.get('q') || '';
  const page = params.get('page') ? parseInt(params.get('page'), 10) : 1;

  const updateParams = (updates) => {
    const newParams = new URLSearchParams(location.search);
    Object.entries(updates).forEach(([key, value]) => newParams.set(key, value));
    history.push({ pathname: '/projects', search: `?${newParams.toString()}` });
  };

  const setQuery = (newQuery) => {
    const newParams = new URLSearchParams(location.search);
    if (newQuery) {
      newParams.set('q', newQuery);
    } else {
      newParams.delete('q');
    }
    newParams.set('page', 1);
    history.push({ pathname: '/projects', search: `?${newParams.toString()}` });
  };

  return (
    <Grid id="projects" stackable>
      <Grid.Row columns={2}>
        <Grid.Column width={4}>
          <ProjectSearchInput query={query} setQuery={setQuery} />
        </Grid.Column>
        <Grid.Column textAlign="right" floated="right">
          <CreateProjectButton />
        </Grid.Column>
      </Grid.Row>
      {query ? (
        <SearchProjects
          query={query}
          page={page}
          setPage={(newPage) => updateParams({ page: newPage })}
        />
      ) : (
        <AllProjects />
      )}
    </Grid>
  );
};

export default Projects;
